import { WebStorage } from "./webStorage";
import { WebStorageNames } from "./constants";
import { clearSelectedComp, clearSelectedOffice, removeSpace } from "../components/Global/CustomFunctions";

export const SUPER_ADMIN_ROLE_ID = 1;

/** Current role id from storage (number), or null if missing/invalid. */
export const getStoredRoleId = () => {
  try {
    const raw = WebStorage.getLocalStore(WebStorageNames.RoleId);
    if (raw === null || raw === undefined || raw === "") return null;
    const roleId = parseInt(raw, 10);
    return Number.isFinite(roleId) ? roleId : null;
  } catch (_) {
    return null;
  }
};

/** True only for Super Admin (roleId === 1). */
export const isSuperAdminRole = (roleId = getStoredRoleId()) => {
  const id = typeof roleId === "number" ? roleId : parseInt(roleId, 10);
  return id === SUPER_ADMIN_ROLE_ID;
};

/** True when Super Admin (roleId 1) has entered a tenant company. */
export const isSuperAdminInCompany = () => {
  try {
    if (!isSuperAdminRole()) return false;
    const flag = WebStorage.getLocalStore(WebStorageNames.SuperAdminInCompany);
    return flag === true || flag === "true";
  } catch (_) {
    return false;
  }
};

/** Platform mode: Super Admin on SA home (not inside a tenant). */
export const isSuperAdminPlatformMode = () => {
  try {
    return isSuperAdminRole() && !isSuperAdminInCompany();
  } catch (_) {
    return false;
  }
};

/**
 * Enter a company as Super Admin surrogate.
 * Sets selectedCompany + context flag so X-Company-Id is sent and full SidebarMenu shows.
 */
export const enterSuperAdminCompany = (company, history) => {
  if (!isSuperAdminRole() || !company) return;
  const id = company.id || company.Id;
  const name = company.name || company.Name;
  if (!id || !name) return;

  const obj = { id, name };
  localStorage.setItem("selectedCompany", JSON.stringify(obj));
  WebStorage.setLocalStore(WebStorageNames.SelectedCompany, obj);
  WebStorage.setLocalStore(WebStorageNames.SuperAdminInCompany, true);

  if (history) {
    const slug = removeSpace(String(name).toLowerCase());
    history.push(`/${slug}/offices`);
  }
};

/** Exit tenant context and return to Super Admin platform dashboard. */
export const exitSuperAdminCompany = (history) => {
  WebStorage.setLocalStore(WebStorageNames.SuperAdminInCompany, false);
  localStorage.removeItem("superAdminInCompany");
  clearSelectedComp();
  clearSelectedOffice();
  if (history) {
    history.push("/workplaces");
  }
};
